export default {
  okText: 'ç¡®å®',
  dismissText: 'åæ¶',
  extra: 'è¯·éæ©',
};
